var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 73,
    viewBox: "0 0 389 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.6258 61.3418L148.976 38.9018C149.517 38.6713 149.978 38.2867 150.303 37.796C150.627 37.3053 150.8 36.73 150.8 36.1418C150.8 35.5536 150.627 34.9783 150.303 34.4876C149.978 33.9969 149.517 33.6123 148.976 33.3818L96.6258 10.9418C96.1725 10.7441 95.6771 10.6623 95.1843 10.7039C94.6915 10.7455 94.2168 10.9091 93.8031 11.18C93.3893 11.4509 93.0495 11.8205 92.8143 12.2555C92.5791 12.6905 92.4559 13.1773 92.4558 13.6718L92.4258 27.5018C92.4258 29.0018 93.5358 30.2918 95.0358 30.4718L137.426 36.1418L95.0358 41.7818C93.5358 41.9918 92.4258 43.2818 92.4258 44.7818L92.4558 58.6118C92.4558 60.7418 94.6458 62.2118 96.6258 61.3418Z",
    fill: "#244C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.426 36.1421V36.1721M182.624 36.1421V36.1721M194.822 36.1421V36.1721M207.021 36.1421V36.1721M219.219 36.1421V36.1721",
    stroke: "#244C84",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296.426 18.1421C296.426 14.8421 293.726 12.1421 290.426 12.1421H242.426C239.126 12.1421 236.426 14.8421 236.426 18.1421V54.1421C236.426 57.4421 239.126 60.1421 242.426 60.1421H290.426C293.726 60.1421 296.426 57.4421 296.426 54.1421V18.1421ZM290.426 18.1421L266.426 33.1421L242.426 18.1421H290.426ZM290.426 54.1421H242.426V24.1421L266.426 39.1421L290.426 24.1421V54.1421Z",
    fill: "#244C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/email_success.1382dfb260a8b9f619adcc81e7eab6f0.svg";
export { ForwardRef as ReactComponent };